import React, { useEffect, useState } from 'react';
import UploadWidget from './UploadWidget';
import DocumentList from '../../../components/DocumentList';
import { getJobList } from '../../../utils/Api'
import DocumentUpload from '../../../modals/DocumentUpload';

const HomeInfo = () => {
    const [documentList, setDocumentList] = useState([]);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getRecentDocuments = async () => {
            try {
                const { data } = await getJobList("");
                setDocumentList(data);
            } catch (error) {
                setError(error.message);
            }
        }
        getRecentDocuments()
    }, []);

    return (
        <React.Fragment>
            <div className="flex flex-col items-center p-5 md:p-10 bg-slate-50 text-slate-800 font-sans space-y-6 border-slate-300 shadow-2xl border-r-1 justify-center">
                <h1 className="font-bold text-3xl text-slate-700">Welcome</h1>

                <div className="w-full max-w-md flex flex-row gap-4 items-center justify-around">
                    <UploadWidget description="Create New Document" onClick={() => setIsCreateModalOpen(true)} enabled={true} />
                    <UploadWidget description="Add Pages to Document" enabled={false}/>
                </div>

                <div className="w-full max-w-2xl flex-grow bg-white rounded-lg p-4 shadow-sm border border-slate-200 flex flex-col gap-4">
                    <h2 className="text-lg font-semibold text-slate-700 px-2">Recent Documents</h2>
                    <div className="flex-grow overflow-y-auto">
                        <DocumentList documentList={documentList} setDocumentList={setDocumentList} selectable={false} />
                    </div>
                </div>

                <div className="text-center">
                    <h2 className="text-sm font-semibold text-slate-600">BETA RELEASE</h2>
                    <p className="text-xs text-slate-500 max-w-lg mt-1">
                        This service is under active development. You may encounter occasional issues.
                        We welcome your feedback at <a
                            href="mailto:issues@data-revival.com"
                            className="underline text-blue-600 hover:text-blue-800"
                        >
                            issues@data-revival.com
                        </a>.
                    </p>
                </div>
            </div>
            <DocumentUpload isOpen={isCreateModalOpen} setIsOpen={setIsCreateModalOpen} mode="create" />
        </React.Fragment>
    );
}

export default HomeInfo;